import Vue from 'vue'

Vue.component('ShowcaseQuote', {
  props: ['quoteData']
})
